import _ from 'lodash';
import { createSelector } from 'reselect';

import { sortCountiesByStates } from 'utils/counties';

import { selectLoanApplication } from './loanApplication.selectors';

const selectCounties = createSelector(selectLoanApplication, ({ counties }) => counties);

export const selectIsCountiesExist = createSelector(selectCounties, counties => !!counties.length);

export const selectSortedCountiesByStates = createSelector(selectCounties, sortCountiesByStates);

export const selectAlphabeticallySortedCountiesByStates = createSelector(
  selectCounties,
  counties => {
    const sortedCounties = _.sortBy(counties, [county => _.toLower(county.value)]);

    return sortCountiesByStates(sortedCounties);
  },
);
